import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';

import { CobrancaService } from '../../../../shared/services/cobranca/cobranca.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';
import * as moment from 'moment';


declare var $: any;

@Component({
  selector: 'app-proximas-transacoes',
  templateUrl: './proximas-transacoes.component.html',
  styleUrls: ['./proximas-transacoes.component.scss']
})
export class ProximasTransacoesComponent implements OnInit, AfterViewInit {
  public inputSearch = '';
  public cobrancas: any[] = [];
  public table: any[] = [];
  public error = false;
  public loaded = false;

  constructor(
    private cobrancaService: CobrancaService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.getData();
  }

  getData() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.cobrancaService.obterCobrancasFuturas(user.PersonId).subscribe((cobrancas: any) => {
      cobrancas.forEach((cobranca) => {
        cobranca.DataCobranca = moment(cobranca.DataCobranca).format('DD/MM/YYYY');
        cobranca.Valor = cobranca.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      });

      this.loaded = true;
      this.cobrancas = cobrancas;

      this.showData();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;
    this.table = $('#master-detail-table-proximas-transacoes').DataTable({
      scrollX: true,
      destroy: true,
      paging: true,
      pagingType: 'numbers',
      lengthChange: false,
      searching: false,
      processing: false,
      info: true,
      data: self.cobrancas,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function() {
        self.loaded = true;

        if (self.cobrancas && self.cobrancas.length === 0) {
          $('#master-detail-table-proximas-transacoes_info').html('0 - 0 de 0');
        }
      },
      columns: [
        { title: 'Cliente', data: 'Cliente.Nome' },
        { title: 'Descrição', data: 'Venda.Descricao' },
        { title: 'Data', data: 'DataCobranca' },
        { title: 'Valor', data: 'Valor' },
      ],
    });
  }

  setFilterData(e) {
    // todo
  }

  filter() {
    // todo
  }
}
